import React, { useEffect, useRef } from "react";

const SpecifySection = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("active");
          } else {
            e.target.classList.remove("active");
          }
        });
      },
      { threshold: 0.2 }
    );
    const el = sectionRef.current;
    if (el) observer.observe(el);
    return () => {
      if (el) observer.unobserve(el);
    };
  }, []);

  return (
    <section className="hp-specify" style={{ background: "#fff" }}>
      <div className="sp-banner-wrap hp-reveal" ref={sectionRef}>
        <img
          src="/kuku-assets/images/banner.png"
          alt="Kuku Namkeen product benefits"
          className="sp-banner"
        />
      </div>
    </section>
  );
};

export default SpecifySection;
